export default "__VITE_ASSET__0aCguy8O__"